export const endpoints = {
  favouriteItem: 'validFavourite',
  languageOptions: 'validFavourite/language/options',
  ownerOptions: 'validFavourite/owner/options',
  favouriteTypeOptions: 'validFavourite/type/options',
  sharedWithUserGroups: 'validFavourite/usergroup/options',
  sharedWithUsers: 'validFavourite/sharedWithUsers/options',
  deleteSchedule: (id: number) => `validFavourite/${id}/schedule`
};
